import React, { LegacyRef, useState, useCallback } from 'react';
import { CubeIcon } from '@fronton/icons-react';
import { ButtonWithGAClickButton, MobileFixedPanelStructure, Typography } from 'common/components';
import { MobileFixedPanelModal } from 'common/components/design-registration-panel/components/mobile-fixed-panel/mobile-fixed-panel-modal';
import { ThemeProvider } from 'fronton-react';
import {
  KITCHEN_SIGN_UP_HREF,
  KITCHEN_CALCULATOR_HREF,
  KITCHEN_ELEMENT_BLOCK,
} from '../../../../../kitchen-constants';
import {
  newKitchenSignSectionPanel,
  newKitchenSignSectionPanelButtons,
  newKitchenSignSectionPanelIcon,
  newKitchenSignSectionPanelMobileButton,
  newKitchenSignSectionPanelText,
  newKitchenSignSectionPanelWrapper,
} from './new-kitchen-sign-section-panel-styles';

type NewKitchenSignSectionPanelProps = {
  panelRef: LegacyRef<HTMLDivElement>;
  regionId: string;
};

const mobilePanelStructure: MobileFixedPanelStructure = {
  content: {
    icon: CubeIcon,
    iconColor: 'accent-primary',
    iconType: 'duotone',
    text: `Запишитесь на\u00A0проектирование или рассчитайте примерную стоимость кухни в\u00A0нашем калькуляторе`,
  },
  mobileButton: {
    openModal: true,
    label: 'Записаться на проектирование',
  },
  actionBlock: [],
};

export const NewKitchenSignSectionPanel: React.FC<NewKitchenSignSectionPanelProps> = ({
  regionId,
  panelRef,
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const signUpHref = `${KITCHEN_SIGN_UP_HREF}${regionId}`;

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleOpenModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  return (
    <ThemeProvider>
      <div ref={panelRef} className={newKitchenSignSectionPanelWrapper}>
        <div className={newKitchenSignSectionPanel}>
          <CubeIcon
            className={newKitchenSignSectionPanelIcon}
            size="40px"
            color="var(--accent-primary)"
            type="duotone"
            strokeWidth={0.5}
          />
          <Typography
            className={newKitchenSignSectionPanelText}
            variant="s"
            size="body_short"
            color="text-invert">
            Запишитесь на&nbsp;проектирование или рассчитайте примерную стоимость кухни в&nbsp;нашем
            калькуляторе
          </Typography>
          <div className={newKitchenSignSectionPanelButtons}>
            <ButtonWithGAClickButton
              elementBlock={KITCHEN_ELEMENT_BLOCK}
              elementName="Приезжайте в гости — посмотрите кухни вживую"
              elementText="Узнать цену"
              invert
              variant="pseudo"
              href={KITCHEN_CALCULATOR_HREF}
              target="_blank"
              size="m">
              Узнать цену
            </ButtonWithGAClickButton>
            <ButtonWithGAClickButton
              elementBlock={KITCHEN_ELEMENT_BLOCK}
              elementName="Приезжайте в гости — посмотрите кухни вживую"
              elementText="Записаться"
              variant="accent"
              href={signUpHref}
              target="_blank"
              size="m">
              Записаться
            </ButtonWithGAClickButton>
          </div>
        </div>

        <ButtonWithGAClickButton
          className={newKitchenSignSectionPanelMobileButton}
          elementBlock={KITCHEN_ELEMENT_BLOCK}
          elementName="Приезжайте в гости — посмотрите кухни вживую"
          elementText="Записаться на проектирование"
          variant="accent"
          adaptive={false}
          wide
          onClick={handleOpenModal}>
          Записаться на&nbsp;проектирование
        </ButtonWithGAClickButton>

        <MobileFixedPanelModal
          elementName="Приезжайте в гости — посмотрите кухни вживую"
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          structure={{
            ...mobilePanelStructure,
            actionBlock: [
              {
                elementBlock: KITCHEN_ELEMENT_BLOCK,
                href: signUpHref,
                label: 'Записаться',
                target: '_blank',
                variant: 'accent',
              },
              {
                elementBlock: KITCHEN_ELEMENT_BLOCK,
                invert: true,
                label: 'Узнать цену',
                variant: 'pseudo',
                href: KITCHEN_CALCULATOR_HREF,
                target: '_blank',
              },
            ],
          }}
        />
      </div>
    </ThemeProvider>
  );
};
